import { useEffect } from "react";

// The running build version (shown in the navbar). Constant per loaded bundle.
export const APP_VERSION = typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : "dev";

// Ensures a running tab never stays on an old build. It polls /version.json
// (served no-store) and, when the deployed version differs from the one this tab
// booted with, reloads once to pick up the latest. A per-version sessionStorage
// guard prevents reload loops during the brief deploy window.
const CURRENT = APP_VERSION;
const GUARD_KEY = "__ctsb_reloaded_for";

export default function VersionGuard() {
  useEffect(() => {
    let alive = true;

    async function check() {
      try {
        const res = await fetch(`/version.json?ts=${Date.now()}`, { cache: "no-store" });
        if (!res.ok || !alive) return;
        const data = (await res.json()) as { version?: string };
        const latest = data?.version;
        if (!latest) return;
        if (latest !== CURRENT) {
          // New deploy is live — reload once to load it.
          if (sessionStorage.getItem(GUARD_KEY) === latest) return; // already tried this version
          sessionStorage.setItem(GUARD_KEY, latest);
          window.location.reload();
        }
      } catch {
        /* offline / transient — try again next tick */
      }
    }

    const id = setInterval(check, 60_000);
    const onVisible = () => {
      if (document.visibilityState === "visible") check();
    };
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", check);
    check();

    return () => {
      alive = false;
      clearInterval(id);
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("focus", check);
    };
  }, []);

  // Logic-only — the version is displayed in the navbar.
  return null;
}
